export const feetAndInchesToInches = ({
  feet,
  inches
}: {
  feet?: number | string | null;
  inches?: number | string | null;
}) => {
  return Number(feet || 0) * 12 + Number(inches || 0);
};
